<template>
  <div class="account-container">
    <SettingsCardSkeletonLoader v-if="pageLoading" />
    <div v-else>
      <Icims
        v-if="isIcims"
        :ats-name="config.atsName"
        :guidance="guidance"
        :support-email="supportEmail"
        :logo-url="logoUrl"
      />
      <Greenhouse
        v-if="isGreenhouse"
        :ats-name="config.atsName"
        :guidance="guidance"
        :support-email="supportEmail"
        :logo-url="logoUrl"
      />
      <Workday
        v-if="isWorkday"
        :ats-name="config.atsName"
        :guidance="guidance"
        :support-email="supportEmail"
        :logo-url="logoUrl"
      />
      <SmartRecruiters
        v-if="isSmartRecruiters"
        :ats-name="config.atsName"
        :logo-url="logoUrl"
        :support-email="supportEmail"
        :sr-info="smartRecruitersInfo"
      />
      <Lever
        v-if="isLever"
        :ats-name="config.atsName"
        :logo-url="logoUrl"
        :support-email="supportEmail"
        :lever-info="leverInfo"
      />
      <SuccessFactors
        v-if="isSuccessFactors"
        :ats-name="config.atsName"
        :guidance="guidance"
        :support-email="supportEmail"
        :logo-url="logoUrl"
      />
      <PermissionErrorModal />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useSettingsConfig } from '@/stores/settings/config';
import { useSettingsIntegrations } from '@/stores/settings/integrations';
import { useSettingsIntegrationsForm } from '@/stores/settings/integrationsForm';
import SettingsCardSkeletonLoader from '@/components/shared/SkeletonLoaders/settings/SettingsCardSkeletonLoader.vue';
import SuccessFactors from '@/components/settings/integrations/SuccessFactors.vue';
import Greenhouse from '@/components/settings/integrations/Greenhouse.vue';
import Icims from '@/components/settings/integrations/Icims.vue';
import Workday from '@/components/settings/integrations/Workday.vue';
import SmartRecruiters from '@/components/settings/integrations/SmartRecruiters.vue';
import Lever from '@/components/settings/integrations/Lever.vue';
import PermissionErrorModal from '../components/PermissionErrorModal.vue';

export default {
  name: 'IntegrationSettings',
  components: {
    SettingsCardSkeletonLoader,
    Greenhouse,
    Icims,
    Workday,
    SmartRecruiters,
    Lever,
    SuccessFactors,
    PermissionErrorModal,
  },
  computed: {
    ...mapState(useAppLoading, ['componentLoading', 'pageLoading']),
    ...mapState(useSettingsConfig, ['config']),
    ...mapState(useSettingsIntegrations, [
      'alreadySubmitted',
      'smartRecruitersInfo',
      'leverInfo',
      'supportEmail',
      'logoUrl',
      'guidance',
      'submitSuccess',
      'isSmartRecruiters',
      'isLever',
      'isWorkday',
      'isGreenhouse',
      'isSuccessFactors',
      'isIcims',
    ]),
    ...mapState(useSettingsIntegrationsForm, [
      'values',
      'errors',
      'errorMessages',
      'labels',
      'isFormValid',
    ]),
  },
  async mounted() {
    await this.load();
  },
  methods: {
    ...mapActions(useSettingsIntegrationsForm, [
      'setFormValues',
      'setIsValidated',
    ]),
    ...mapActions(useSettingsIntegrations, ['load', 'submit']),
  },
};
</script>

<style scoped lang="less">
@import '@/less/mixins';

.account-container {
  width: 100%;
}

:deep(.v-card) {
  .shadow() !important;
}

.v-card-header {
  background-color: transparent;
  box-shadow: none !important;
}

:deep(.panel) {
  width: 50%;
}

:deep(.panel-container) {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

:deep(.text-title) {
  margin: 0 0 8px 0;
  padding: 0;
  font-size: 16px !important;
  font-weight: 500 !important;
}
</style>
